<script lang="ts">
  import {
    recaptcha,
    recaptchaToken,
    apiUrl,
    showRecaptchaV3,
  } from 'Store/InvestorFlowStore';
  import {transitionToAuthentication} from 'Utility/investorFlow/transitionFunction';
  import RecaptchaV3 from 'Components/Common/RecaptchaV3.svelte';
  import {onMount} from 'svelte';
  import {loadInvestorAccessLink} from 'Store/InvestorFlowStore';

  let recaptchaBox: HTMLElement;
  let recaptchaWrapper: HTMLElement;
  let recaptchaInstance: RecaptchaV3;

  $: showRecaptcha =
    $recaptcha.sitekey && $recaptcha.sitekey_v3 && $recaptcha.render;

  const reCaptchaWidth = 304;
  const scaleRecaptcha = new ResizeObserver(entries => {
    // Recaptcha iframe width is 304px by default with regular options setup
    const rect = entries[0].contentRect;

    // Exclude viewports when input's width is dynamic with screen size.
    // 415px limit need to be included as a limit for not having undesired oversized re-captcha iframe
    if (!(window.innerWidth >= 415 && window.innerWidth <= 767)) {
      const recaptchaScale = rect.width / reCaptchaWidth;
      if (recaptchaBox) {
        recaptchaBox.style.transform = `scale(${recaptchaScale})`;
      }
    }
  });

  onMount(() => {
    scaleRecaptcha.observe(recaptchaWrapper);
  });

  const refreshRecaptcha = () => {
    recaptchaInstance.refreshV3().then(() => {
      handleRecaptchaToken();
    });
  };

  const handleRecaptchaToken = () => {
    const url = new URL(window.location.href);
    const investorId = url.searchParams.get('returning_investor');

    loadInvestorAccessLink(investorId, $recaptchaToken, $showRecaptchaV3)
      .then(() => {
        transitionToAuthentication();
      })
      .catch(error => {
        console.error('Error loading investor access link:', error);
      });
  };
</script>

{#if showRecaptcha}
  <div
    class="g-recaptcha"
    bind:this={recaptchaWrapper}
    data-testid="recaptcha-container"
  >
    <RecaptchaV3
      bind:this={recaptchaInstance}
      bind:recaptchaV2Box={recaptchaBox}
      baseUrl={$apiUrl}
      recaptchaSiteKey={$recaptcha.sitekey}
      invisibleRecaptchaSiteKey={$recaptcha.sitekey_v3}
      on:tokenLoaded={refreshRecaptcha}
    />
  </div>
{/if}

<style lang="postcss">
  .g-recaptcha {
    position: absolute;
    text-align: center;
    padding-left: 40%;
    padding-top: 5rem;
    align-items: center;
    transform-origin: 0 0;

    /* Specific breakpoint for devices viewport under default recaptcha width 304px (for this page it reaches in 360)*/
    @media screen and (max-width: 360px) {
      width: 13.875rem;
    }

    @media screen and (min-width: 415px) and (max-width: 768px) {
      margin: 0 auto;
    }
  }
</style>
